import Repository from './repository';

const resource = '/comply/search';
export default {
	checkTypes(payload) {
		return Repository.getWithAuth(`${resource}/checktypes`, payload);
	},
	retrySearch(id) {
		return Repository.getWithAuth(`${resource}/retry/${id}`);
	},
	newSearch(payload, customHeaders) {
		return Repository.postWithAuth(`${resource}`, payload, customHeaders);
	},
	find(payload, customHeaders) {
		return Repository.postWithAuth(`${resource}/find`, payload, customHeaders, {
			noCache: true,
		});
	},
	findByID(id, date, customHeaders) {
		return Repository.getWithAuthAndPayload(
			`${resource}/${id}`,
			date === '' ? '' : date,
			customHeaders
		);
	},
	paginateHits(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/hits/paginate`,
			payload,
			customHeaders
		);
	},
	changeMonitor(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/monitor`,
			payload,
			customHeader,
			{ noCache: true }
		);
	},
	changeMonitorBatch(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/monitor/batch`,
			payload,
			customHeader,
			{ noCache: true }
		);
	},
	downloadSelectedSearches(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/csv/batch`,
			payload,
			customHeader
		);
	},
	updateWhiteList(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/whitelist`,
			payload,
			customHeader,
			{ noCache: true }
		);
	},
	createNotes(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/createnotes`,
			payload,
			customHeader,
			{ noCache: true }
		);
	},
	createNotesBatch(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/createnotes/batch`,
			payload,
			customHeader,
			{ noCache: true }
		);
	},
	getNotes(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/getnotes`,
			payload,
			customHeader,
			{ noCache: true }
		);
	},
	reviewUpdate(payload) {
		return Repository.postWithAuth(`${resource}/review_update`, payload);
	},
	reviewCAUpdate(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/update`,
			payload,
			customHeaders
		);
	},
	updateStatus(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/updatestatus`,
			payload,
			customHeader
		);
	},
	updateClientReference(payload, customHeader) {
		return Repository.postWithAuth(
			`${resource}/update-client-reference`,
			payload,
			customHeader
		);
	},
	notifyOnXLSXDownload(payload, customHeader) {
		return Repository.postWithAuth(`${resource}/excel`, payload, customHeader);
	},
	downloadPDF(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/certificate`,
			payload,
			customHeaders
		);
	},
	downloadPDFOldEndpoint(payload, customHeaders) {
		return Repository.postWithAuth(`${resource}/pdf`, payload, customHeaders);
	},
	getAnalyzerRequests(payload, customHeader) {
		return Repository.postWithAuth(
			`comply/analyzer/requests`,
			payload,
			customHeader
		);
	},
	createBatch(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/batch/create`,
			payload,
			customHeaders
		);
	},
	uploadBatchRecords(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/batch/insert`,
			payload,
			customHeaders
		);
	},
	startBatchProcess(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/batch/start`,
			payload,
			customHeaders
		);
	},
	listBatchRecords(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/batch/records`,
			payload,
			customHeaders
		);
	},
	listBatchSearches(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/batch/list`,
			payload,
			customHeaders
		);
	},
	startBatchCertificateDownload(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/batch/certificates/download`,
			payload,
			customHeaders
		);
	},
	listBatchCertificateDownloads(payload, customHeaders) {
		return Repository.postWithAuth(
			`${resource}/batch/certificates/download/list`,
			payload,
			customHeaders
		);
	},
	getBatchCertificateDownloadStatus(batchId, customHeaders) {
		return Repository.getWithAuth(
			`${resource}/batch/certificates/detail/${batchId}`,
			batchId,
			customHeaders
		);
	},
	downloadBatchCertificates(payload, customHeaders) {
		return Repository.getWithAuth(
			`${resource}/batch/certificates/${payload.batchId}/download`,
			payload,
			customHeaders
		);
	},
	deleteSearch(id, customHeaders) {
		return Repository.deleteWithAuth(`${resource}/${id}`, {}, customHeaders);
	},
	deleteSearchesBatch(payload, customHeaders) {
		return Repository.deleteWithAuth(
			`${resource}/batch`,
			payload,
			customHeaders
		);
	},
};
